export const getRefundValid = (
  status: 'success' | 'pending' | 'rejected' | undefined,
  amount: string | number,
  setError: (string: string) => void,
  isInvalidStatus: boolean,
  totalAmount?: string | number,
) => {
  const getValid = status === 'success' && Number(totalAmount) >= Number(amount)
  if (getValid) {
    return
  } else if (isInvalidStatus) {
    setError('Transaction has aleady failed!')
    return
  } else {
    setError('Refund amount cant be more than transaction amount')
  }
}
